import React, { ReactNode } from 'react';

import { CheckIcon, XMarkIcon } from '@heroicons/react/24/solid';
import classNames from 'classnames';

interface FieldValidationProps {
  children: ReactNode;
  className?: string;
}

const FieldValidation = ({ children, className }: FieldValidationProps) => {
  return <div className={classNames('flex flex-col gap-1 items-start', className)}>{children}</div>;
};

interface CriteriaProps {
  message: string;
  isValid: boolean;
}

FieldValidation.Criteria = ({ message, isValid }: CriteriaProps) => {
  const iconElement = isValid ? (
    <CheckIcon className="w-4 h-4 text-green-500" />
  ) : (
    <XMarkIcon className="w-4 h-4 text-red-500" />
  );

  return (
    <div className="flex items-center gap-1.5">
      {iconElement}
      <span className="text-white text-[15px]">{message}</span>
    </div>
  );
};

export default FieldValidation;
